export default __webpack_public_path__ + "static/about-1732521638f2ca8f365666228ecd49c7.jpg";